import * as React from "react";
import { Box } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { DrawingBomContext } from "../../../DrawingBomContext";
import { drawingMaterialsCols } from "../../../../Components/cols/drawingsMaterialsCols";
import { drawingMcsDataCols } from "../../../../Components/cols/drawingMaterialsMcsDataCols";
import { lightTable } from "../../../../../../../../../../styles/muiProps";
import { secondAxios } from "../../../../../../../../../../api/axios";

export default function MaterialsTable({ drawing }) {
  const { changeSelectionMaterials } = React.useContext(DrawingBomContext);

  const [drawingRevs, setDrawingRevs] = React.useState([]);

  const getDrawingRevisions = async (drawingId) => {
    const res = await secondAxios.get(`drawing/all-revs/${drawingId}`);
    const sortedDrawings =
      res?.data?.sort((a, b) => a.createdAt - b.createdAt) || [];

    // console.log("Drawing Revisions:", sortedDrawings);
    setDrawingRevs(sortedDrawings);
  };

  React.useEffect(() => {
    getDrawingRevisions(drawing.id);
  }, []);

  const data = React.useMemo(() => {
    return [...(drawing.materials || [])]
      .map((m) =>
        m.description
          ? { ...m, drawing, drawingRevs }
          : {
              ...m,
              drawing,
              drawingRevs,
              description:
                m?.taggedMaterial?.component + m?.taggedMaterial?.size,
            },
      )
      .sort((a, b) =>
        String(a.tagNumber || a.item).localeCompare(
          String(b.tagNumber || b.item),
          undefined,
          { numeric: true },
        ),
      );
  }, [drawing.materials, drawingRevs]);

  // console.log("After:", data);

  const table = useMaterialReactTable({
    data,

    columns: [
      ...drawingMaterialsCols(drawing?.materials),
      ...drawingMcsDataCols,
    ],
    initialState: {
      sorting: [{ id: "tagNumber", desc: false }],
    },
    enableRowSelection: true,
    ...lightTable,
    // layoutMode: "grid",
    enableStickyHeader: true,
    muiTableContainerProps: { sx: { maxHeight: "400px" } },
    getRowId: (row) => String(row.id),
    // onRowSelectionChange: onRowSelection,
    // state: { rowSelection },
  });

  React.useEffect(() => {
    const selectedMaterialsIds = Object.keys(table.getState().rowSelection);

    const selectedMaterials = selectedMaterialsIds.map((id) => {
      return drawing.materials.find((m) => m.id === id);
    });
    const drawingSelectedMaterials = {};

    drawingSelectedMaterials[drawing.id] = selectedMaterials;
    changeSelectionMaterials(drawingSelectedMaterials);
  }, [table.getState().rowSelection]);

  return (
    <Box sx={{ maxHeight: 400, backgroundColor: "#fff" }}>
      <MaterialReactTable table={table} />
    </Box>
  );
}
